import React, { useReducer } from 'react';
import { 
    SET_SIGNALR_HUB, 
    SET_CHAT_NEW_MESSAGE_WARNING, 
    GET_CHAT_NEW_MESSAGE_WARNING 
} from './HubActionType';
import HubReducer from './HubReducer';
import HubContext from './HubContext';


const HubState = props => {
    const initialState = {
        hubConnection: null,
        chatNewMessageWarning: []
    };
    const[state, dispatch] = useReducer(HubReducer, initialState);
    
    const setHubConnection = (value) => {
        dispatch({
            type: SET_SIGNALR_HUB,
            payload: value
        })
    }

    const setChatNewMessageWarning = (value) => {
        dispatch({
            type: SET_CHAT_NEW_MESSAGE_WARNING,
            payload: value
        })
    }

    return <HubContext.Provider
        value = {
            {
                hubConnection: state.hubConnection,
                chatNewMessageWarning: state.chatNewMessageWarning,
                setHubConnection,
                setChatNewMessageWarning 
            }
        }        
    >
        { props.children }
    </HubContext.Provider>

}

export default HubState;